import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import Autocomplete from '@mui/material/Autocomplete';
import MDInput from "../../../materialDashboard/components/MDInput";
import {useMunicipalityInfiniteQuery, useMunicipalityQuery} from "./query";
import {debounce} from "../../../utils/debounce";
import {getScrollHandler, LoadingAdornment} from "../utils";


const MunicipalityAutocomplete = ({provinceId, regionId, MDInputProps={}, value, onChange, disabled, ...props}) => {
    const [municipalitySearch, setMunicipalitySearch] = useState("");

    let filter =  {
        province_id: provinceId,
        province__region_id: regionId,
        search: municipalitySearch,
        order_by: "name",
    }

    const municipalitiesQuery = useMunicipalityInfiniteQuery(filter, !disabled);
    // Query to have the selected value always available, when the value is given and is not in the first page
    const municipalityQuery = useMunicipalityQuery(value, {staleTime: Infinity});

    const municipalities = municipalitiesQuery.data?.pages?.flatMap((page) => page.items) ?? [];
    const selectedMunicipality = municipalities.find(m => m.id === value) ?? municipalityQuery.data;

    const options = [
        ...(selectedMunicipality ? [selectedMunicipality] : []),
        ...municipalities.filter((s) => !selectedMunicipality || selectedMunicipality.id !== s.id),
    ]

    const handleSearchChange = debounce((value) => {
        setMunicipalitySearch(value);
    }, 300);

    useEffect(() => {
        if(value===null || value===undefined) {
            setMunicipalitySearch("");
        }
    }, [value]);

    return (
        <Autocomplete
            fullWidth
            isOptionEqualToValue={(option, value) => {
                return option.id === value.id
            } }
            options={options}
            filterOptions={(x) => x}
            autoHighlight
            getOptionLabel={(option) => option.name ?? ""}
            onChange={(event, newValue) => onChange(newValue?.id)}
            value={selectedMunicipality ?? null}
            loading={municipalities.isFetching || municipalityQuery.isFetching}
            disabled={disabled}
            onClose={() => handleSearchChange("")}
            renderOption={(props, option) => {
                const { key, ...optionProps } = props;
                return (
                    <Box key={key} component="li" {...optionProps}>
                        {option.name}
                    </Box>
                );
            }}
            ListboxProps={{onScroll: getScrollHandler(municipalitiesQuery)}}
            renderInput={(params) => (
                <MDInput
                    {...params}
                    label="Choose a municipality"
                    onChange={(e) => handleSearchChange(e.target.value)}
                    inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off', // disable autocomplete and autofill
                    }}
                    variant="standard"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (<LoadingAdornment infiniteQuery={municipalitiesQuery} params={params}/> ),
                    }}
                    {...MDInputProps}
                />
            )}
            {...props}
        />
    );
}

export default MunicipalityAutocomplete;